

















































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { UserModule } from '@/store/modules/user.module'
import Avatar from '@/components/Avatar.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import { IUser, IUserOverdueHistory } from '@zunta/configurations'
const sortBy = require('lodash.sortby')

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    Avatar,
    ScrollView,
    LoaderWrapper
  }
})
export default class AdminUsersPanel extends Vue {
  userInstanceModule: UserModule = getModule(UserModule, this.$store);
  mode: string = 'users';
  params: any = {
    userId: null,
    skip: 0,
    weeks: 7
  };
  historyData: any = null
  selectedAdmin: IUser | null = null;
  isLoading: boolean = false;
  isIniting: boolean = true;

  get dashboardData () {
    return this.$store.state.user.dashboardData
  }

  get displayDashboardData () {
    const usersOrder = [
      'Ahuva Ginsberger',
      'Esther Singer',
      'Bayla Stern',
      'Tina Shor',
      'Annette Panish',
      'Tzip Klitnick'
    ].map((name) => name.toLocaleLowerCase())
    return sortBy(this.dashboardData.filter((userData: any) => {
      return !!userData.tasks.due ||
        !!userData.tasks.overdue ||
        !!userData.tasks.completed ||
        !!userData.alerts.due ||
        !!userData.alerts.overdue ||
        !!userData.alerts.completed ||
        !!userData.chainsCount ||
        !!userData.facilitiesCount ||
        !!userData.usersCount
    }), (userData: any) => {
      const index = usersOrder.indexOf(`${userData.admin.firstName} ${userData.admin.lastName}`.toLocaleLowerCase())
      return index === -1 ? 1000000 : index
    })
  }

  get userOverdueHistory () {
    return this.$store.state.user.userOverdueHistory
  }

  async mounted () {
    this.initDashboardDataCharts()
    this.isIniting = false
  }

  initDashboardDataCharts () {
    this.displayDashboardData.forEach((userData: any) => {
      const alertsMax = Math.max(...userData.history.map((item: IUserOverdueHistory) => {
        return item.totalAlerts
      }))

      const tasksMax = Math.max(...userData.history.map((item: IUserOverdueHistory) => {
        return item.totalTasks
      }))
      userData.alertsData = userData.history.reverse().map((item: IUserOverdueHistory) => {
        return {
          total: alertsMax,
          data: [{
            items: [
              {
                color: '#FFDFBF',
                value: item.totalAlerts - item.overdueAlerts,
                label: 'Other Alerts:'
              },
              {
                color: '#FF6633',
                value: item.overdueAlerts,
                label: 'Overdue Alerts:'
              }
            ]
          }]
        }
      })
      userData.tasksData = userData.history.reverse().map((item: IUserOverdueHistory) => {
        return {
          total: tasksMax,
          data: [{
            items: [
              {
                color: '#FFDFBF',
                value: item.totalTasks - item.overdueTasks,
                label: 'Other Tasks:'
              },
              {
                color: '#FF6633',
                value: item.overdueTasks,
                label: 'Overdue Tasks:'
              }
            ]
          }]
        }
      })
    })
  }

  showStatistics (admin: IUser) {
    this.params.userId = admin.id
    this.selectedAdmin = admin
    this.params.weeks = 7
    this.fetchUserOverdueHistory()
    this.mode = 'user-chart'
  }

  async fetchUserOverdueHistory () {
    this.isLoading = true
    await this.userInstanceModule.fetchUserOverdueHistory(this.params)
    this.initHistoryData()
    this.isLoading = false
  }

  initHistoryData () {
    const alertsMax = Math.max(...this.userOverdueHistory.map((item: IUserOverdueHistory) => {
      return item.totalAlerts
    }))

    const tasksMax = Math.max(...this.userOverdueHistory.map((item: IUserOverdueHistory) => {
      return item.totalTasks
    }))
    this.historyData = {
      total: Math.max(tasksMax, alertsMax),
      data: this.userOverdueHistory.reverse().map((item: IUserOverdueHistory) => {
        return {
          weekNumber: item.weekNumber,
          year: item.year,
          tasks: [{
            border: '#9966FF',
            items: [
              {
                color: '#FFDFBF',
                value: item.totalTasks - item.overdueTasks,
                label: 'Other Tasks:'
              },
              {
                color: '#FF6633',
                value: item.overdueTasks,
                label: 'Overdue Tasks:'
              }
            ]
          }],
          alerts: [{
            border: '#FF6633',
            items: [
              {
                color: '#FFDFBF',
                value: item.totalAlerts - item.overdueAlerts,
                label: 'Other Alerts:'
              },
              {
                color: '#FF6633',
                value: item.overdueAlerts,
                label: 'Overdue Alerts:'
              }
            ]
          }]
        }
      })
    }
  }

  slideTo (skip: number) {
    this.params.skip += skip
    this.fetchUserOverdueHistory()
  }

  isPrevAvailable () {
    return this.userOverdueHistory && this.userOverdueHistory.length === 7
  }

  isNextAvailable () {
    return this.params.skip !== 0
  }

  goUsersMode () {
    this.mode = 'users'
  }
}
